import PropTypes from "prop-types";
import * as React from "react";
import { Link } from "react-router-dom";
import { mutate } from "swr";
import { Influencer } from "../../../domain";
import fetcher from "../../../hooks/fetcher";
import { getInitials } from "../../../util/text";
import UpcomingEvent from "../../../components/Home/Section/UpcomingEvent";
import s from "./ShopCard.module.css";

function textFor({ famousFor, famousCharacter }) {
  if (famousFor && famousCharacter) {
    return `${famousCharacter} / ${famousFor}`;
  }

  if (famousFor) {
    return famousFor;
  }

  if (famousCharacter) {
    return famousCharacter;
  }

  return "";
}

export default function ShopCard({ shop }) {
  const description = textFor(shop);

  const handleMouseEnter = React.useCallback(() => {
    const endpoints = Influencer.getPreloadEndpoints(shop);

    if (endpoints) {
      endpoints.filter(Boolean).forEach((endpoint) => {
        mutate(endpoint, fetcher(endpoint));
      });
    }
  }, [shop]);

  return (
    <Link
      to={`/${shop.route}`}
      className={s.card}
      onMouseEnter={handleMouseEnter}
    >
      {shop.isLive ? <span className={s.liveBadge}>LIVE</span> : null}

      <div className={s.imageWrap}>
        {shop.avatarUrl ? (
          <img
            className={s.avatar}
            src={shop.avatarUrl}
            alt=""
            width="162"
            height="216"
            loading="lazy"
          />
        ) : (
          <span className={s.avatarFallback} aria-hidden="true">
            {getInitials(shop.name)}
          </span>
        )}

        <UpcomingEvent influencer={shop} />
      </div>

      <div className={s.info}>
        <p className={s.name}>{shop.name}</p>
        {Boolean(description) && <p className={s.text}>{description}</p>}
      </div>
    </Link>
  );
}

ShopCard.propTypes = {
  shop: PropTypes.shape({
    influencerId: PropTypes.number,
    route: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    avatarUrl: PropTypes.string,
    isLive: PropTypes.bool,
    famousFor: PropTypes.string,
    famousCharacter: PropTypes.string,
  }).isRequired,
};
